<template>
  <div>
    <TButton
      outline
      :size="buttonSize"
      @click="handleShowModal()"
    >
      <TIcon
        :icon="['far', 'cube']"
        fixed-width
        class="mr-2"
      />
      {{ t('explore') }}
    </TButton>

    <TModalInfo
      v-model:visible="showModal"
      size="full"
      :title="t('explore')"
      disable-close-button
      mobile-type="overlay"
    >
      <iframe
        :src="`${src}&brand=0&dh=0&tour=0&gt=0&mt=0&fp=0&search=0&title=0&vr=0&mls=0`"
        allowfullscreen
        :title="t('explore')"
        class="border-0 w-full h-[calc(max(400px,75vh))] rounded-lg"
      />
    </TModalInfo>
  </div>
</template>

<script setup lang="ts">
import type { ButtonSize } from '~/components/_tailwind/button/types'

withDefaults(defineProps<{
  src: string
  buttonSize?: ButtonSize
}>(), {
  buttonSize: 'sm',
})

const { t } = useI18n()

const showModal = ref(false)

function handleShowModal() {
  showModal.value = true
}
</script>

<i18n lang="json">
{
  "en": {
    "explore": "Explore in 3D"
  },
  "fr": {
    "explore": "Explorer en 3D"
  }
}
</i18n>
